import React from 'react'
import { IIconProps as IProps } from './IIconProps'

/** A closed chain: this skill is one record, hanging on more than one job. */
const IconLinked = (props: IProps) => (
  <svg
    style={{
      width: `${props.size}px`,
      height: `${props.size}px`,
    }}
    viewBox="0 0 64.67 64.67"
  >
    <path
      fill={props.color}
      d="M36.5635 5.01748C42.9918 -1.67249 53.4652 -1.67249 59.8936 5.01748C66.2572 11.6404 66.2572 22.3311 59.8936 28.954L48.0166 41.3153C47.0202 42.3524 45.921 43.2336 44.7491 43.954C38.4066 47.8523 30.1011 46.9515 24.6856 41.3153C23.8196 40.4141 23.0704 39.4364 22.4395 38.4032C21.576 36.9892 22.0225 35.1427 23.4366 34.2792C24.8506 33.4157 26.6971 33.8622 27.5606 35.2763C27.9682 35.9438 28.4517 36.5752 29.0118 37.1581C32.4513 40.7378 37.6426 41.2779 41.6065 38.8417C42.3441 38.3883 43.0453 37.8286 43.6895 37.1581L55.5674 24.7968C59.6997 20.4961 59.6997 13.4754 55.5674 9.1747C51.5 4.94164 44.9571 4.94163 40.8897 9.1747L38.2735 11.8974C37.1255 13.0921 35.226 13.1303 34.0313 11.9823C32.8367 10.8344 32.7994 8.93481 33.9473 7.74013L36.5635 5.01748Z"
    />
    <path
      fill={props.color}
      d="M16.6504 23.3508C23.0788 16.6605 33.553 16.6607 39.9815 23.3508C40.8473 24.2519 41.5958 25.23 42.2266 26.2629C43.0902 27.6769 42.6445 29.5234 41.2305 30.3869C39.8165 31.2505 37.97 30.8039 37.1065 29.3899C36.6989 28.7224 36.2153 28.0909 35.6553 27.508C31.5879 23.275 25.0451 23.2751 20.9776 27.508L9.09965 39.8703C4.96738 44.171 4.96736 51.1908 9.09965 55.4914C13.1671 59.7246 19.7099 59.7246 23.7774 55.4914L26.3946 52.7678C27.5425 51.5731 29.442 51.5349 30.6368 52.6828C31.8314 53.8308 31.8687 55.7303 30.7207 56.925L28.1036 59.6487C21.6751 66.3389 11.2009 66.339 4.7725 59.6487C-1.59086 53.0258 -1.5908 42.336 4.7725 35.7131L16.6504 23.3508Z"
    />
  </svg>
)

export default IconLinked
